<template>
  <div class="downloadCenter">
    <div class="zxzx_div">
      <ul class="zxzx_ul">
        <li>下载中心</li>
        <li
          @click="liName('通知公告', 17)"
          :class="[tabName === '通知公告' ? 'liActive' : '']"
        >
          通知公告
        </li>
        <li
          @click="liName('参展文件', 18)"
          :class="[tabName === '参展文件' ? 'liActive' : '']"
        >
          参展文件
        </li>
        <li
          @click="liName('报馆文件', 19)"
          :class="[tabName === '报馆文件' ? 'liActive' : '']"
        >
          报馆文件
        </li>
      </ul>
    </div>
    <div class="right_content">
      <div class="title">
        <span>当前位置：&nbsp;</span>
        <span>资讯中心</span>
        <span>></span>
        <span>{{ tabName }}</span>
      </div>
      <div class="content">
        <ul>
          <li v-for="(item, index) in informationTypeList" :key="index">
            <div class="leftDiv">
              <span class="fileName">{{ item.title }}</span>
              <span style="margin: 0 9px">-</span>
              <span style="cursor: pointer">
                <a :href="downLoad(item)" style="color: #333333">下载</a>
              </span>
            </div>
            <div class="rightDiv">
              {{ item.uploadDate ? item.uploadDate : item.createDate }}
            </div>
          </li>
        </ul>
      </div>

      <el-pagination
        background
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-size="pageSize"
        layout="prev, pager, next, slot"
        :total="totalPage"
      >
        <el-input type="text" v-model="pageNum"></el-input>
        <el-button class="tz" @click="pageTz">跳转</el-button>
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "downloadCenter", // 资讯中心
  components: {},
  data() {
    return {
      tabName: "",
      pageIndex: 1,
      pageSize: 10,
      pageNum: null,
      totalPage: 0,
      informationTypeList: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    let sessionTabName = JSON.parse(sessionStorage.getItem("mainStore"));
    if (sessionTabName && sessionTabName.name) {
      switch (sessionTabName.name) {
        case "通知公告":
          this.liName(sessionTabName.name, 17);
          break;
        case "参展文件":
          this.liName(sessionTabName.name, 18);
          break;
        case "报馆文件":
          this.liName(sessionTabName.name, 19);
          break;
        default:
          this.liName("通知公告", 17);
      }
    } else {
      this.liName("通知公告", 17);
    }
  },
  methods: {
    liName(e, num) {
      this.tabName = e;
      this.$http({
        url: "getInformationList",
        method: "post",
        params: {
          type: num,
        },
      })
        .then(({ data }) => {
          let { code, informationByTypeList } = data;
          if (code === 0) {
            informationByTypeList.forEach((ele) => {
              ele.createDate = ele.createDate.substring(0, 10);
              ele.uploadDate = ele.uploadDate
                ? ele.createDate.substring(0, 10)
                : "";
            });
            this.informationTypeList = informationByTypeList;
          }
        })
        .catch((err) => console.log(err));
      sessionStorage.setItem("mainStore", JSON.stringify({ name: e }));
    },

    downLoad(row) {
      return this.$http.adornUrl(row.content);
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
    },
    pageTz() {
      this.pageIndex = this.pageNum;
    },
  },
};
</script>
<style lang="scss">
.downloadCenter {
  .btn-prev,
  .btn-next {
    width: 52px;
    height: 32px;
    color: #eeeeee;
  }
  .el-icon-arrow-left:before {
    content: "上一页";
  }
  .el-icon-arrow-right:before {
    content: "下一页";
  }
  .el-pager {
    height: 32px;
    .active {
      background-color: #17327e !important;
    }
    .number {
      height: 100%;
      width: 32px;
      line-height: 32px;
      &:hover {
        background-color: #17327e !important;
        color: #ffffff !important;
      }
    }
  }
  .btn-quicknext {
    height: 32px;
    line-height: 32px !important;
  }
  .el-pagination {
    text-align: center;
    margin: 63px 0 70px 0;
    .el-input {
      width: 32px;
      height: 32px;
      .el-input__inner {
        border-radius: 0;
        width: 32px;
        height: 32px;
        padding: 0;
      }
    }
    .el-button {
      width: 54px;
      height: 32px;
      background-color: #eeeeee;
      color: #525252;
      margin-left: 8px;
      span {
        line-height: 32px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.downloadCenter {
  .zxzx_div {
    width: 238px;
    height: 256px;
    border-right: 1px solid #4bbc81;
    border-bottom: 1px solid #4bbc81;
    border-left: 1px solid #02b3ea;
    float: left;
    .zxzx_ul {
      color: #999999;
      font-weight: bold;
      li {
        width: 100%;
        height: 64px;
        line-height: 64px;
        text-indent: 31px;
        font-size: 16px;
        cursor: pointer;
      }
      li:first-child {
        font-size: 24px;
        font-weight: normal;
        color: #fff;
        cursor: default;
        background-image: linear-gradient(to right, #02b3ea, #4bbc81);
      }
      li:nth-child(3) {
        height: 62px;
        border-top: 1px dashed #f2f2f2;
        border-bottom: 1px dashed #f2f2f2;
      }
    }
  }
  .right_content {
    width: 936px;
    float: right;
    height: 1177px;
    background-color: #ffffff;
    box-shadow: -8px 0px 8px #fafafa, 0px -8px 8px #fafafa, 0px 8px 8px #fafafa;
    margin: 0 0 45px 0;
  }
  .liActive {
    color: #143372;
  }
  .title {
    height: 43px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 43px;
    padding-left: 17px;
    color: #b6b6b6;
    font-size: 12px;
    span:nth-child(3) {
      margin: 0 11px;
    }
  }
  .content {
    width: 857px;
    height: 942px;
    margin: 10px auto 21px;
    ul {
      list-style: square;
      //   list-style-position: inside;
      li {
        height: 59px;
        line-height: 59px;
        border-bottom: 1px solid #dfe1e1;
        .leftDiv {
          span {
            display: inline-block;
            float: left;
          }
          max-width: 500px;
          float: left;
          font-size: 14px;
          color: #333333;
          overflow: hidden;
          .fileName {
            max-width: 400px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .rightDiv {
          float: right;
          font-size: 12px;
          color: #bbbbbb;
        }
      }
    }
  }
}
</style>